"use client";

import React from "react";
import { ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted/10 animate-pulse rounded-none" />)}
      </div>;
  }
  return <ul className="flex flex-col gap-4">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors duration-300 font-default text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  return <section data-section-id="230395" id="footer" className="bg-background text-foreground border-t border-primary pt-16 pb-8 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-24">
          
          <div className="flex flex-col gap-6 lg:pr-8">
            <Link to="/" className="inline-block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661389/img/benchmark_media_logo.png" alt="BENCHMARK MEDIA" className="h-7 w-auto" />
            </Link>
            <p className="text-muted-foreground leading-relaxed text-sm font-default">
              Benchmark Media Consulting is an elite advertising consultancy delivering data-driven marketing strategies and architectural brand solutions for global enterprises.
            </p>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="font-default font-bold text-lg uppercase tracking-tighter text-foreground">Solutions</h3>
            <MenuProvider menu_id="51">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="font-default font-bold text-lg uppercase tracking-tighter text-foreground">Method & Insights</h3>
            <div className="flex flex-col gap-4 text-muted-foreground font-mono text-xs">
              <div>
                <p className="text-foreground mb-1 uppercase font-bold">Headquarters</p>
                <p>2226 GLENGALLON WAY, HOPE ISLAND, QLD, 4212, Australia</p>
              </div>
              <div>
                <p className="text-foreground mb-1 uppercase font-bold">Consultation</p>
                <p>Mon-Fri: 0800 - 1800</p>
              </div>
              <div>
                <p className="text-foreground mb-1 uppercase font-bold">Direct</p>
                <p>info@benchmarkmediaconsulting.com</p>
                <p>+61485040630</p>
              </div>
            </div>
          </div>

        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center pt-8 border-t border-border gap-6">
          <p className="text-muted-foreground text-xs font-mono uppercase tracking-widest">
            &copy; {new Date().getFullYear()} BENCHMARK MEDIA CONSULTING | <Link to="#" className="hover:text-primary">LEGAL</Link> | <Link to="#" className="hover:text-primary">PRIVACY</Link>
          </p>
          
          <Button variant="outline" size="sm" onClick={scrollToTop} className="rounded-none border-primary text-foreground hover:bg-primary hover:text-primary-foreground font-mono uppercase tracking-widest text-[10px] h-10 px-6 transition-all shadow-sm hover:shadow-primary/20">
            Elevate to Top
            <ArrowUp className="ml-2 size-4" />
          </Button>
        </div>
      </div>
    </section>;
}